import type { MainMenuItemType } from '#base/core/types/MainMenuItemType';

export default (menuType: 'desktop' | 'mobile' = 'desktop'): MainMenuItemType[] => {
	const items: MainMenuItemType[] = [];

	if (menuType === 'mobile') {
		items.push({
			text: 'Home',
			to: {
				title: 'Fit Hier homepage',
				url: '/',
				newTab: false,
			},
		});
	}

	items.push({
		text: 'Small Group Training',
		to: {
			title: 'Small Group Training',
			url: '/small-group-training',
			newTab: false,
		},
		submenu: {
			items: [
				{
					text: 'Small Group Training',
					description: 'Trainen in kleine groepen van 6 personen',
					icon: 'fa-people-group',
					to: {
						title: 'Small Group Training',
						url: '/small-group-training',
						newTab: false,
					},
				},
				{
					text: 'Trainingsschema & tijden',
					description: 'Bekijk ons wekelijks lesaanbod',
					icon: 'fa-calendar-days',
					to: {
						title: 'Small Group Training lesrooster',
						url: '/small-group-training/trainingsschema-en-tijden',
						newTab: false,
					},
				},
				{
					text: 'Functional Conditioning',
					description: 'Uitdagende functionele conditietraining',
					icon: 'fa-person-running',
					to: {
						title: 'Small Group Training - Functional Conditioning',
						url: '/small-group-training/functional-conditioning-conditietraining',
						newTab: false,
					},
				},
				{
					text: 'Functional Strength',
					description: 'Krachttraining met functionele focus',
					icon: 'fa-dumbbell',
					to: {
						title: 'Small Group Training - Functional Strength',
						url: '/small-group-training/functional-strength-krachttraining',
						newTab: false,
					},
				},
				{
					text: 'LifeFit',
					description: 'Laagdrempelige training voor mobiliteit & conditie',
					icon: 'fa-heart-circle-plus',
					to: {
						title: 'Small Group Training - LifeFit',
						url: '/small-group-training/lifefit-functionele-begeleide-fitness',
						newTab: false,
					},
				},
			],
			banner: {
				title: 'Claim jouw gratis proefles Small Group Training',
				image: {
					src: '/img/fitness/small-group-training_01.jpg',
					alt: 'Small Group Training',
					width: 826,
					height: 466,
				},
				to: {
					url: '/small-group-training/aanmelden-proefles',
					title: 'Proefles Small Group Training',
				},
				buttonText: 'Direct inschrijven',
			},
		},

	});

	items.push({
		text: 'Private Group Training',
		to: {
			title: 'Trainen met je eigen groep',
			url: '/private-group-training',
			newTab: false,
		},
		submenu: {
			items: [
				{
					text: 'Private Group Training',
					description: 'Trainen met je eigen groep',
					icon: 'fa-users-rectangle',
					to: {
						title: 'Private Group Training',
						url: '/private-group-training',
						newTab: false,
					},
				},
				{
					text: 'Atleten & Sportteams',
					description: 'Pre- In- & Post-season trainen',
					icon: 'fa-volleyball',
					to: {
						title: 'Private Group Training',
						url: '/private-group-training#training-voor-sportteams',
						newTab: false,
					},
				},
				{
					text: 'Teams & Bedrijven',
					description: 'Vitaliteit en teamdynamiek',
					icon: 'fa-handshake-angle',
					to: {
						title: 'Private Group Training',
						url: '/private-group-training#bedrijfsfitness',
						newTab: false,
					},
				},
				{
					text: 'Vrienden & Familie',
					description: 'Trainen met gezin of vrienden',
					icon: 'fa-people-roof',
					to: {
						title: 'Private Group Training',
						url: '/private-group-training#sporten-met-vrienden-of-familie',
						newTab: false,
					},
				},
			],
			banner: {
				title: 'Informatie aanvragen over Private Group Training',
				image: {
					src: '/img/fitness/private-group-training_01.jpg',
					alt: 'Private Group Training',
					width: 826,
					height: 466,
				},
				to: {
					url: '/private-group-training#aanmelden',
					title: 'Informatie aanvragen over Private Group Training',
				},
				buttonText: 'Informatie aanvragen',
			},
		},
	});

	items.push({
		text: 'Personal Training',
		to: {
			title: 'Trainen met een personal trainer',
			url: '/personal-training',
			newTab: false,
		},
	});

	items.push({
		text: 'MamaFit',
		to: {
			title: 'Training tijdens én na je zwangerschap',
			url: '/mamafit',
			newTab: false,
		},
	});

	if (menuType === 'mobile') {
		items.push({
			text: 'Vacatures',
			counter: countVacancies('fit'),
			to: {
				title: 'Werken bij Fit Hier',
				url: 'https://werkhier.com',
				newTab: true,
			},
		});
	}

	return items;
};
